'use client'

import { createPageReadinessTelemetry } from '@brew/observability/browser'

/** Each phase describes the foreground content that the page actually gates. */
export const PAGE_READINESS_CONTRACTS = {
  audience: {
    domain: 'audience',
    phase: 'contacts_grid',
    matches: (path: string) => path === '/audience',
  },
  events: {
    domain: 'analytics',
    phase: 'overview_and_feed',
    matches: (path: string) => path === '/events',
  },
  analytics: {
    domain: 'analytics',
    phase: 'summary_activity_trends',
    matches: (path: string) => path === '/analytics',
  },
  automations: {
    domain: 'automation',
    phase: 'inventory_rows',
    matches: (path: string) => path === '/automations',
  },
  automation_canvas: {
    domain: 'automation',
    phase: 'canvas_revealed',
    matches: (path: string) => /^\/automations\/[^/]+$/.test(path),
    ignoredSearchKeys: ['automationIds', 'chat'],
  },
  email_groups: {
    domain: 'email',
    phase: 'group_cards',
    matches: (path: string) => path === '/emails',
  },
  email_canvas: {
    domain: 'email',
    phase: 'canvas_revealed',
    matches: (path: string) => /^\/emails\/(?:grp_[^/]+|ungrouped)$/.test(path),
    ignoredSearchKeys: [
      'focusEmailIds',
      'focusMode',
      'emailIds',
      'commentId',
      'chat',
    ],
  },
} as const

export const pageReadiness = createPageReadinessTelemetry(
  PAGE_READINESS_CONTRACTS
)
